import React, { useEffect, useState } from "react";
import ActionItems from "../Result/ActionItems";
import Footer from '../../Company/About/Footer';
import TestScoreCard from "../Result/TestScoreCard";
import { useLocation } from "react-router-dom";
import Blocks from "./Blocks";
import { Container } from '@/components/ui/layout';
import { cn } from '@/lib/utils';
import Navbar from "../../Company/About/Navbar";
import ImageGallery from "./img";
import Hero from "../../Company/CompanyHome/Hero";
import { useNavigate } from "react-router-dom";

function MainResult() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [screeningData, setScreeningData] = useState(null);
  const [personalityData, setPersonalityData] = useState(null);
  const [behaviorData, setBehaviorData] = useState(null);
  const [testDate, setTestDate] = useState(null);
  const [testTime, setTestTime] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { candidate, jobDetails } = location.state || {}; // Safely access ranking and jobDetails
  const [ptDate, setPtDate] = useState(null);
  const [btDate, setBtDate] = useState(null);
  const [stDate, setStDate] = useState(null);


  console.log("Candidate:", candidate);
  const jobId = new URLSearchParams(location.search).get("jobID");
  const [activeTab, setActiveTab] = useState("results");
  const fetchTestResults = async () => {
    try {
      const formattedScreeningData = {
        title: "Screening Test Score",
        score: `${candidate.details.screening_score}%`,
        confidenceScore: `${candidate.details.confidence_score}%`,
        domainScore: `${candidate.details.domain_score}%`,
        metrics: [
          {
            name: "Grammar Score",
            score: `${candidate.details.Grammar_Score}/10`,
            percentage: candidate.details.Grammar_Score * 10,
            color: "#008000",
          },
          {
            name: "Pauses Score",
            score: `${candidate.details.Pauses}/10`,
            percentage: candidate.details.Pauses * 10,
            color: "#FF8C00",
          },
          {
            name: "Pitch",
            score: `${candidate.details.Pitch}/10`,
            percentage: candidate.details.Pitch * 10,
            color: "#FFDD01",
          },
          {
            name: "Volume",
            score: `${candidate.details.Volume}/10`,
            percentage: candidate.details.Volume * 10,
            color: "#F9577E",
          },
          {
            name: "Speech Rate",
            score: `${candidate.details.rate}/10`,
            percentage: candidate.details.rate * 10,
            color: "#1EACFE",
          },
        ],
        NULL: "N/A",
      };

      setScreeningData(formattedScreeningData);

      const formattedPersonalityData = {
        title: "Personality Test Score",
        metrics: [
          {
            name: "Extroversism Score",
            score: `${candidate.details.Introversion_vs_Extroversion}/10`,
            percentage: candidate.details.Introversion_vs_Extroversion * 10,
            color: "#008000",
          },
          {
            name: "Emotional Stability Score",
            score: `${candidate.details.Emotional_Stability}/10`,
            percentage: candidate.details.Emotional_Stability * 10,
            color: "#FF8C00",
          },
          {
            name: "Openness to Experience Score",
            score: `${candidate.details.Openness_to_Experience}/10`,
            percentage: candidate.details.Openness_to_Experience * 10,
            color: "#FFDD01",
          },
          {
            name: "Agreeableness Score",
            score: `${candidate.details.Agreeableness}/10`,
            percentage: candidate.details.Agreeableness * 10,
            color: "#F9577E",
          },
          {
            name: "Conscientiousness Score",
            score: `${candidate.details.Conscientiousness}/10`,
            percentage: candidate.details.Conscientiousness * 10,
            color: "#F9577E",
          },
        ],
        NULL: "N/A",
      };

      setPersonalityData(formattedPersonalityData);

      const formattedBehaviorData = {
        title: "Behavior Test Score",
        metrics: [
          {
            name: "Problem Solving",
            score: `${candidate.details.Problem_Solving}/10`,
            percentage: candidate.details.Problem_Solving * 10,
            color: "#008000",
          },
          {
            name: "Communication Skills",
            score: `${candidate.details.Communication_Skills}/10`,
            percentage: candidate.details.Communication_Skills * 10,
            color: "#FF8C00",
          },
          {
            name: "Handling Pressure",
            score: `${candidate.details.Handling_Pressure}/10`,
            percentage: candidate.details.Handling_Pressure * 10,
            color: "#FFDD01",
          },
          {
            name: "Ownership and Responsibility",
            score: `${candidate.details.Ownership_and_Responsibility}/10`,
            percentage: candidate.details.Ownership_and_Responsibility * 10,
            color: "#F9577E",
          },
          {
            name: "Value and Ethics",
            score: `${candidate.details.Values_and_Ethics}/10`,
            percentage: candidate.details.Values_and_Ethics * 10,
            color: "#1EACFE",
          },
        ],
        NULL: "Not Scheduled",
      };

      setBehaviorData(formattedBehaviorData);

      const dateTimeString = candidate.details.test_date;

      // Manually reformat the date string to a valid ISO format
      const reformatDate = (dateString) => {
        // Example format: "Tue, 07 Jan 2025 09:53:19 GMT"
        const [weekday, day, month, year, time, timezone] = dateString.split(" ");
        // Rebuild into ISO 8601 format "YYYY-MM-DDTHH:mm:ssZ"
        const monthNames = { Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12' };
        const monthNumber = monthNames[month];
        return `${year}-${monthNumber}-${day}T${time}Z`;
      };

      // Reformat the date string and parse it into a Date object
      const isoDateTimeString = reformatDate(dateTimeString);

      // Create a Date object
      const dateObj = new Date(isoDateTimeString);

      // Check for invalid date (in case the parsing fails)
      if (isNaN(dateObj)) {
        console.error("Invalid date format");
      } else {
        // Format the test date (e.g., January 7, 2025)
        const testDate = dateObj.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });

        // Format the test time (e.g., 9:53 AM)
        const testTime = dateObj.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true, // 12-hour format
        });

        // Assuming you have functions `setTestDate` and `setTestTime` to update state
        setTestDate(testDate);
        setTestTime(testTime);

        console.log("Test Date:", testDate); // January 7, 2025
        console.log("Test Time:", testTime); // 9:53 AM
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Call the fetch function on mount
    fetchTestResults();
  }, []);

  useEffect(() => {
    if (candidate?.details) {
      if (candidate.details.screening_test_scheduled_time) {
        setStDate(new Date(candidate.details.screening_test_scheduled_time));
      }
      if (candidate.details.personality_test_scheduled_time) {
        setPtDate(new Date(candidate.details.personality_test_scheduled_time));
      }
      if (candidate.details.behavioral_test_scheduled_time) {
        setBtDate(new Date(candidate.details.behavioral_test_scheduled_time));
      }
    }
  }, [candidate]); // runs this effect when candidate changes
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const formatDate = (date) => date ? date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }) : null;


  return (
    <div className="page-container">
      <Navbar />
      <Hero />
      <div className="all-candidates">
        <div className="ranking-job-header-v2">
          <h2>{jobDetails.job_title}</h2>
          <p>{jobDetails.location} | {jobDetails.experience_range} | Job Code: {jobId}</p>
        </div>
        <div className="tabs2-v22">
          <button></button>
          <button className={activeTab === "applications" ? "active-tab" : ""} onClick={() => { setActiveTab("applications"); navigate(`/ranking?jobID=${jobId}`) }}>Applications</button>
          <button></button>
          <button className={activeTab === "results" ? "active-tab" : ""} onClick={() => {
            setActiveTab("results");
            navigate(`/results?jobID=${jobId}`);
          }}>Interview Result</button>
          <button></button>
        </div>

        <input type="text" className="search-bar-all" style={{ width: '70%' }} placeholder="Search candidates" />

        <ImageGallery candidate={candidate} />


        <main className="results-content">

          <div className="blocks-and-candidate-list">
            <div className="candidate-card-v2222" >
              <div className="header-and-score">
                <div className="candidate-header-v22">
                  <img src="user.jpg" alt="Avatar" className="avatar-v2" />
                  <div>
                    <h3 className="candidate-name-v22">{candidate.details.name}</h3>
                    <p className="candidate-info-v22">Experience: {candidate.details.experience}</p>
                    <p className="candidate-info-v22 qualification-truncate" title={candidate.details?.qualification || ''}>
                      Qualification: {candidate.details?.qualification
                        ? candidate.details.qualification.length > 30
                          ? candidate.details.qualification.slice(0, 30) + "..."
                          : candidate.details.qualification
                        : null}
                    </p>
                    <span className="candidate-score-v22">{candidate.details.screening_score}% Overall Score</span>
                  </div>
                </div>
                {/* <div className="tabs-info-section">
                  <div className="info-block">
                    <strong>Strengths:</strong>
                    <ul className="info-list">
                      {candidate.details.strengths
                        ? candidate.details.strengths
                          .replace(/[\[\]']+/g, "")
                          .split(",")
                          .slice(0, 2)
                          .map((s, i) => <li key={i}>{s.trim()}</li>)
                        : <li>No strengths listed</li>}
                    </ul>
                  </div>

                  <div className="info-block">
                    <strong>Weaknesses:</strong>
                    <ul className="info-list">
                      {candidate.details.weaknesses
                        ? candidate.details.weaknesses
                          .replace(/[\[\]']+/g, "")
                          .split(",")
                          .slice(0, 2)
                          .map((w, i) => <li key={i}>{w.trim()}</li>)
                        : <li>No weaknesses listed</li>}
                    </ul>
                  </div>
                </div> */}
                <div className="scores-sectionnn">
                  <div className="scores-griddd">
                    {candidate.scores && candidate.scores.map((score, scoreIndex) => (
                      <div key={scoreIndex} className="score-itemmm">
                        <img
                          src={score.icon}
                          alt="Score icon"
                          className="score-iconnn"
                          loading="lazy"
                        />
                        <div className="score-texttt">{score.score}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="candidate-actions-v22">
                <button className="action-button-v22 view-resume-v22">View Resume</button>
                {/* <button className="action-button-v22 view-result-v22">View Detail Result</button> */}
                {/* <button className="action-button-v22 coding-test-v22">Coding Test</button> */}
                {/* <button className="action-button-v22 schedule-interview-v22">Schedule Interview</button> */}
              </div>
            </div>
            <Blocks />
          </div>

          <div className="full-results-combined">
            <div className="results-section">
              <TestScoreCard data={screeningData} type="screening" tt={formatDate(stDate)} />
            </div>
            <div className="two-results">
              <div className="results-section">
                <TestScoreCard data={personalityData} type="personality" tt={formatDate(ptDate)} />
              </div>
              <div className="results-section">
                <TestScoreCard data={behaviorData} type="behavior" tt={formatDate(btDate)} />
              </div>
            </div>
          </div>
          <ActionItems 
            strengths={
              [
                ...(candidate.details.Personality_Strength 
                    ? candidate.details.Personality_Strength.replace(/[\[\]']+/g, "").split(",").map(s => s.trim()) 
                    : []),
                ...(candidate.details.Behavioral_Strength 
                    ? candidate.details.Behavioral_Strength.replace(/[\[\]']+/g, "").split(",").map(s => s.trim()) 
                    : [])
              ]
            }
            weaknesses={
              [
                ...(candidate.details.Personality_Weakness 
                    ? candidate.details.Personality_Weakness.replace(/[\[\]']+/g, "").split(",").map(w => w.trim()) 
                    : []),
                ...(candidate.details.Behavioral_Weakness 
                    ? candidate.details.Behavioral_Weakness.replace(/[\[\]']+/g, "").split(",").map(w => w.trim()) 
                    : [])
              ]
            }
          />

          {/* <section className="results-section">

          </section> */}
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default MainResult;